<template>
  <!--个人中心-->
  <div class="dif">
    <!--左侧菜单栏-->
    <div style="flex: 1">
      <el-menu default-active="0" class="el-menu-vertical-demo"
        active-text-color="#3eac4e" @select="openMenu"
      >
        <el-menu-item index="0">
          <span slot="title">考生信息</span>
        </el-menu-item>
        <!--<el-menu-item index="1">-->
        <!--  <span slot="title">资料上传</span>-->
        <!--</el-menu-item>-->
        <el-menu-item index="2">
          <span slot="title">我的活动</span>
        </el-menu-item>
        <el-menu-item index="3">
          <span slot="title">邀请报名</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div style="flex: 4">
      <!--个人资料-->
      <user-info v-show="current==='0'"></user-info>
      <!--资料上传-->
      <up-load-info v-show="current==='1'"></up-load-info>
      <!--我的活动-->
      <my-event v-show="current==='2'"></my-event>
      <!--邀请报名-->
      <invitation v-show="current==='3'"></invitation>
    </div>

  </div>
</template>

<script>
import UserInfo from "@/components/myCenter/userInfo";
import UpLoadInfo from "@/components/myCenter/upLoadInfo";
import Invitation from "@/components/myCenter/invitation";
import MyEvent from "@/components/myCenter/myEvent";
export default {
  name: "myCenter",
  components: {MyEvent, Invitation, UpLoadInfo, UserInfo},
  data() {
    return {
      current: '0',
    }
  },
  methods: {
    openMenu(e) { //点击左侧菜单
      this.current = e
    }
  },
}
</script>

<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 20em;
    min-height: 400px;
  }
  ::v-deep.el-menu-item{
    font-size: 1.6em;
  }
</style>